var _defs, _circle, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _image, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamBhp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.93 5 12 12.26l6.65-3.88A6.09 6.09 0 0 0 15.93 5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.1 12.6-.41-.47c-.09-.11 0-.16.16-.29l6.21-5a.06.06 0 0 1 .07 0l.15.18v.07l-5.87 5.42c-.23.18-.27.14-.31.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.14,
    y1: 11.98,
    x2: 18.17,
    y2: 10.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1016"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}.cls-189{fill:#dd1016}.cls-190{opacity:.9}.cls-191{fill:#f1f2f2}.cls-194{opacity:.7}.cls-197{fill:#ed1c24}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231f20"
    },
    d: "m12.04 12.23.03.03h-.03v-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241f20"
    },
    d: "m12.04 12.16.11.1h-.08l-.03-.03v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251f20"
    },
    d: "m12.04 12.09.18.17h-.07l-.11-.1v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261f20"
    },
    d: "m12.04 12.02.25.24h-.07l-.18-.17v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#271f20"
    },
    d: "m12.04 11.95.33.31h-.08l-.25-.24v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#281f20"
    },
    d: "m12.04 11.88.4.38h-.07l-.33-.31v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#291f20"
    },
    d: "m12.04 11.81.47.45h-.07l-.4-.38v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a1e20"
    },
    d: "m12.04 11.74.54.52h-.07l-.47-.45v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b1e20"
    },
    d: "m12.04 11.67.62.59h-.08l-.54-.52v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c1e20"
    },
    d: "m12.04 11.6.69.66h-.07l-.62-.59v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d1e1f"
    },
    d: "m12.04 11.53.76.73h-.07l-.69-.66v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e1e1f"
    },
    d: "m12.04 11.46.83.8h-.07l-.76-.73v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f1e1f"
    },
    d: "m12.04 11.39.91.87h-.08l-.83-.8v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#301e1f"
    },
    d: "m12.04 11.32.98.94h-.07l-.91-.87v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#311e1f"
    },
    d: "m12.04 11.26 1.05 1h-.07l-.98-.94v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#321e1f"
    },
    d: "m12.04 11.19 1.12 1.07h-.07l-1.05-1v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#331e1f"
    },
    d: "m12.04 11.12 1.2 1.14h-.08l-1.12-1.07v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#341e1f"
    },
    d: "m12.04 11.05 1.27 1.21h-.07l-1.2-1.14v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351e1f"
    },
    d: "m12.04 10.98 1.34 1.28h-.07l-1.27-1.21v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#361d1f"
    },
    d: "m12.04 10.91 1.42 1.35h-.08l-1.34-1.28v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#371d1f"
    },
    d: "m12.04 10.84 1.49 1.42h-.07l-1.42-1.35v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#381d1f"
    },
    d: "m12.04 10.77 1.56 1.49h-.07l-1.49-1.42v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#391d1f"
    },
    d: "m12.04 10.7 1.63 1.56h-.07l-1.56-1.49v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a1d1f"
    },
    d: "m12.04 10.63 1.71 1.63h-.08l-1.63-1.56v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b1d1f"
    },
    d: "m12.04 10.56 1.78 1.7h-.07l-1.71-1.63v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c1d1f"
    },
    d: "m12.04 10.49 1.85 1.77h-.07l-1.78-1.7v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d1d1f"
    },
    d: "m12.04 10.42 1.92 1.84h-.07l-1.85-1.77v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e1d1f"
    },
    d: "m12.04 10.35 2 1.91h-.08l-1.92-1.84v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f1d1e"
    },
    d: "m12.04 10.29 2.07 1.97h-.07l-2-1.91v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#401d1e"
    },
    d: "m12.04 10.21 2.14 2.05h-.07l-2.07-1.97v-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#411d1e"
    },
    d: "m12.04 10.15 2.21 2.11h-.07l-2.14-2.05v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#421c1e"
    },
    d: "m12.04 10.08 2.29 2.18h-.08l-2.21-2.11v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#431c1e"
    },
    d: "m12.04 10.01 2.36 2.25h-.07l-2.29-2.18v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#441c1e"
    },
    d: "m12.04 9.94 2.43 2.32h-.07l-2.36-2.25v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#451c1e"
    },
    d: "m12.04 9.87 2.5 2.39h-.07l-2.43-2.32v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#461c1e"
    },
    d: "m12.04 9.8 2.58 2.46h-.08l-2.5-2.39V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471c1e"
    },
    d: "m12.04 9.73 2.65 2.53h-.07L12.04 9.8v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#481c1e"
    },
    d: "m12.04 9.66 2.72 2.6h-.07l-2.65-2.53v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#491c1e"
    },
    d: "m12.04 9.59 2.8 2.67h-.08l-2.72-2.6v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a1c1e"
    },
    d: "m12.04 9.52 2.87 2.74h-.07l-2.8-2.67v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b1c1e"
    },
    d: "m12.04 9.45 2.94 2.81h-.07l-2.87-2.74v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c1c1e"
    },
    d: "m12.04 9.38 3.01 2.88h-.07l-2.94-2.81v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d1c1e"
    },
    d: "m12.04 9.31 3.09 2.95h-.08l-3.01-2.88v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e1c1e"
    },
    d: "m12.04 9.24 3.16 3.02h-.07l-3.09-2.95v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f1b1e"
    },
    d: "m12.04 9.18 3.23 3.08h-.07l-3.16-3.02v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#501b1e"
    },
    d: "m12.04 9.11 3.3 3.15h-.07l-3.23-3.08v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#511b1e"
    },
    d: "m12.04 9.04 3.38 3.22h-.08l-3.3-3.15v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#521b1d"
    },
    d: "m12.04 8.97 3.45 3.29h-.07l-3.38-3.22v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#531b1d"
    },
    d: "m12.04 8.9 3.52 3.36h-.07l-3.45-3.29V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#541b1d"
    },
    d: "m12.04 8.83 3.59 3.43h-.07L12.04 8.9v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#551b1d"
    },
    d: "m12.04 8.76 3.67 3.5h-.08l-3.59-3.43v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#561b1d"
    },
    d: "m12.04 8.69 3.74 3.57h-.07l-3.67-3.5v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#571b1d"
    },
    d: "m12.04 8.62 3.81 3.64h-.07l-3.74-3.57v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#581b1d"
    },
    d: "m12.04 8.55 3.89 3.71h-.08l-3.81-3.64v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#591b1d"
    },
    d: "M12.04 8.48 16 12.26h-.07l-3.89-3.71v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a1b1d"
    },
    d: "m12.04 8.41 4.03 3.85H16l-3.96-3.78v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b1a1d"
    },
    d: "m12.04 8.34 4.1 3.92h-.07l-4.03-3.85v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c1a1d"
    },
    d: "m12.04 8.27 4.18 3.99h-.08l-4.1-3.92v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d1a1d"
    },
    d: "m12.04 8.2 4.25 4.06h-.07l-4.18-3.99V8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e1a1d"
    },
    d: "m12.04 8.13 4.32 4.13h-.07L12.04 8.2v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f1a1d"
    },
    d: "m12.04 8.07 4.39 4.19h-.07l-4.32-4.13v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#601a1d"
    },
    d: "m12.04 8 4.47 4.26h-.08l-4.39-4.19V8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#611a1d"
    },
    d: "m12.04 7.93 4.54 4.33h-.07L12.04 8v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#621a1d"
    },
    d: "m12.04 7.86 4.61 4.4h-.07l-4.54-4.33v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#631a1d"
    },
    d: "m12.04 7.79 4.68 4.47h-.07l-4.61-4.4v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#641a1c"
    },
    d: "m12.04 7.72 4.76 4.54h-.08l-4.68-4.47v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#651a1c"
    },
    d: "m12.04 7.65 4.83 4.61h-.07l-4.76-4.54v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#661a1c"
    },
    d: "m12.04 7.58 4.9 4.68h-.07l-4.83-4.61v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67191c"
    },
    d: "m12.04 7.51 4.98 4.75h-.08l-4.9-4.68v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68191c"
    },
    d: "m12.04 7.44 5.05 4.82h-.07l-4.98-4.75v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69191c"
    },
    d: "m12.04 7.37 5.12 4.89h-.07l-5.05-4.82v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a191c"
    },
    d: "m12.04 7.3 5.19 4.96h-.07l-5.12-4.89V7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b191c"
    },
    d: "m12.04 7.23 5.27 5.03h-.08L12.04 7.3v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c191c"
    },
    d: "m12.04 7.16 5.34 5.1h-.07l-5.27-5.03v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d191c"
    },
    d: "m12.04 7.09 5.4 5.16-.01.01h-.05l-5.34-5.1v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e191c"
    },
    d: "m12.04 7.03 5.43 5.18-.03.04-5.4-5.16v-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f191c"
    },
    d: "m12.04 6.96 5.47 5.22-.04.03-5.43-5.18v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70191c"
    },
    d: "m12.04 6.89 5.5 5.25-.03.04-5.47-5.22v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71191c"
    },
    d: "m12.04 6.82 5.54 5.28-.04.04-5.5-5.25v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72191c"
    },
    d: "m12.04 6.75 5.57 5.32-.03.03-5.54-5.28v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73191c"
    },
    d: "m12.04 6.68 5.6 5.35-.03.04-5.57-5.32v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74181c"
    },
    d: "m12.04 6.61 5.64 5.38-.04.04-5.6-5.35v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75181c"
    },
    d: "m12.04 6.54 5.67 5.42-.03.03-5.64-5.38v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76181c"
    },
    d: "m12.04 6.52.03-.02 5.68 5.42-.04.04-5.67-5.42v-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 14.924 9.192)",
    style: {
      fill: "#77181b"
    },
    d: "M14.9 5.26h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 14.956 9.15)",
    style: {
      fill: "#78181b"
    },
    d: "M14.93 5.22h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15 9.114)",
    style: {
      fill: "#79181b"
    },
    d: "M14.97 5.19h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.026 9.084)",
    style: {
      fill: "#7a181b"
    },
    d: "M15 5.15h.05v7.86H15z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.07 9.047)",
    style: {
      fill: "#7b181b"
    },
    d: "M15.04 5.12h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.1 9.005)",
    style: {
      fill: "#7c181b"
    },
    d: "M15.07 5.08h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.69 -.72 .72 .69 -1.81 13.72)",
    style: {
      fill: "#7d181b"
    },
    d: "M15.11 5.04h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.171 8.938)",
    style: {
      fill: "#7e181b"
    },
    d: "M15.14 5.01h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.203 8.897)",
    style: {
      fill: "#7f181b"
    },
    d: "M15.18 4.97h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.23 8.867)",
    style: {
      fill: "#81171b"
    },
    d: "M15.21 4.93h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.273 8.83)",
    style: {
      fill: "#82171b"
    },
    d: "M15.25 4.9h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.304 8.788)",
    style: {
      fill: "#83171b"
    },
    d: "M15.28 4.86h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.348 8.751)",
    style: {
      fill: "#84171b"
    },
    d: "M15.32 4.83h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.374 8.721)",
    style: {
      fill: "#85171b"
    },
    d: "M15.35 4.79h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.406 8.68)",
    style: {
      fill: "#86171b"
    },
    d: "M15.38 4.75h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.45 8.643)",
    style: {
      fill: "#87171b"
    },
    d: "M15.42 4.72h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.69 -.72 .72 .69 -1.44 13.86)",
    style: {
      fill: "#88171b"
    },
    d: "M15.45 4.68h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.52 8.576)",
    style: {
      fill: "#89171b"
    },
    d: "M15.49 4.64h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.551 8.534)",
    style: {
      fill: "#8a171a"
    },
    d: "M15.52 4.61h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.578 8.504)",
    style: {
      fill: "#8b171a"
    },
    d: "M15.56 4.57h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.621 8.467)",
    style: {
      fill: "#8c171a"
    },
    d: "M15.59 4.54h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.653 8.426)",
    style: {
      fill: "#8d161a"
    },
    d: "M15.63 4.5h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.685 8.384)",
    style: {
      fill: "#8e161a"
    },
    d: "M15.66 4.46h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.723 8.359)",
    style: {
      fill: "#8f161a"
    },
    d: "M15.7 4.43h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.755 8.317)",
    style: {
      fill: "#90161a"
    },
    d: "M15.73 4.39h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.798 8.28)",
    style: {
      fill: "#91161a"
    },
    d: "M15.77 4.35h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-46.33 15.825 8.25)",
    style: {
      fill: "#92161a"
    },
    d: "M15.8 4.32h.05v7.86h-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93161a"
    },
    d: "m13 5.51.04-.03 5.65 5.4v.06h-.01L13 5.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94161a"
    },
    d: "m13.04 5.48.03-.04 5.62 5.37v.07l-5.65-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95161a"
    },
    d: "m13.07 5.44.04-.03 5.58 5.33v.07l-5.62-5.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96161a"
    },
    d: "m13.11 5.41.03-.04 5.55 5.3v.07l-5.58-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97161a"
    },
    d: "m13.14 5.37.03-.04 5.52 5.27v.07l-5.55-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98161a"
    },
    d: "m13.17 5.33.04-.03 5.48 5.23v.07l-5.52-5.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99161a"
    },
    d: "m13.21 5.3.03-.04 5.45 5.2v.07L13.21 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a151a"
    },
    d: "m13.24 5.26.04-.04 5.41 5.17v.07l-5.45-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b151a"
    },
    d: "m13.28 5.22.03-.03 5.38 5.13v.07l-5.41-5.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c151a"
    },
    d: "m13.31 5.19.04-.04 5.34 5.1v.07l-5.38-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d1519"
    },
    d: "m13.35 5.15.03-.03 5.31 5.06v.07l-5.34-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e1519"
    },
    d: "m13.38 5.12.04-.04 5.27 5.03v.07l-5.31-5.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f1519"
    },
    d: "m13.42 5.08.03-.04 5.24 5v.07l-5.27-5.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a01519"
    },
    d: "m13.45 5.04.04-.03 5.2 4.96v.07l-5.24-5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a11519"
    },
    d: "M13.49 5.01V5h.06l5.14 4.9v.07l-5.2-4.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a21519"
    },
    d: "m13.62 5 5.07 4.84v.06L13.55 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a31519"
    },
    d: "m13.69 5 5 4.77v.07L13.62 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a41519"
    },
    d: "m13.77 5 4.92 4.7v.07l-5-4.77h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a51519"
    },
    d: "m13.84 5 4.85 4.63v.07L13.77 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a61419"
    },
    d: "m13.91 5 4.78 4.56v.07L13.84 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71419"
    },
    d: "m13.98 5 4.71 4.49v.07L13.91 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a81419"
    },
    d: "m14.06 5 4.63 4.42v.07L13.98 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a91419"
    },
    d: "m14.13 5 4.56 4.35v.07L14.06 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aa1419"
    },
    d: "m14.2 5 4.49 4.28v.07L14.13 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ab1419"
    },
    d: "m14.28 5 4.41 4.21v.07L14.2 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ac1419"
    },
    d: "m14.35 5 4.34 4.14v.07L14.28 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad1419"
    },
    d: "m14.42 5 4.27 4.07v.07L14.35 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ae1419"
    },
    d: "m14.49 5 4.2 4v.07L14.42 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#af1418"
    },
    d: "m14.56 5 4.13 3.93V9l-4.2-4h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b01418"
    },
    d: "m14.64 5 4.05 3.86v.07L14.56 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b11418"
    },
    d: "m14.71 5 3.98 3.79v.07L14.64 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b21318"
    },
    d: "m14.78 5 3.91 3.73v.06L14.71 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b31318"
    },
    d: "m14.86 5 3.83 3.66v.07L14.78 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b41318"
    },
    d: "m14.93 5 3.76 3.59v.07L14.86 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b51318"
    },
    d: "m15 5 3.69 3.52v.07L14.93 5H15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b61318"
    },
    d: "m15.07 5 3.62 3.45v.07L15 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b71318"
    },
    d: "m15.15 5 3.54 3.38v.07L15.07 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b81318"
    },
    d: "m15.22 5 3.47 3.31v.07L15.15 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b91318"
    },
    d: "m15.29 5 3.4 3.24v.07L15.22 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ba1318"
    },
    d: "m15.36 5 3.33 3.17v.07L15.29 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bb1318"
    },
    d: "m15.44 5 3.25 3.1v.07L15.36 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bc1318"
    },
    d: "m15.51 5 3.18 3.03v.07L15.44 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd1318"
    },
    d: "m15.58 5 3.11 2.96v.07L15.51 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be1318"
    },
    d: "m15.65 5 3.04 2.89v.07L15.58 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf1218"
    },
    d: "m15.73 5 2.96 2.82v.07L15.65 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c01218"
    },
    d: "m15.8 5 2.89 2.75v.07L15.73 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c11218"
    },
    d: "m15.87 5 2.82 2.68v.07L15.8 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c21217"
    },
    d: "m15.95 5 2.74 2.62v.06L15.87 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c31217"
    },
    d: "m16.02 5 2.67 2.55v.07L15.95 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c41217"
    },
    d: "m16.09 5 2.6 2.48v.07L16.02 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c51217"
    },
    d: "m16.16 5 2.53 2.41v.07L16.09 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c61217"
    },
    d: "m16.24 5 2.45 2.34v.07L16.16 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c71217"
    },
    d: "m16.31 5 2.38 2.27v.07L16.24 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c81217"
    },
    d: "m16.38 5 2.31 2.2v.07L16.31 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c91217"
    },
    d: "m16.45 5 2.24 2.13v.07L16.38 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca1217"
    },
    d: "m16.53 5 2.16 2.06v.07L16.45 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb1117"
    },
    d: "m16.6 5 2.09 1.99v.07L16.53 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc1117"
    },
    d: "m16.67 5 2.02 1.92v.07L16.6 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cd1117"
    },
    d: "m16.75 5 1.94 1.85v.07L16.67 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce1117"
    },
    d: "m16.82 5 1.87 1.78v.07L16.75 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf1117"
    },
    d: "m16.89 5 1.8 1.71v.07L16.82 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d01117"
    },
    d: "m16.96 5 1.73 1.64v.07L16.89 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d11117"
    },
    d: "m17.04 5 1.65 1.58v.06L16.96 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d21117"
    },
    d: "m17.11 5 1.58 1.51v.07L17.04 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d31117"
    },
    d: "m17.18 5 1.51 1.44v.07L17.11 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d41116"
    },
    d: "m17.25 5 1.44 1.37v.07L17.18 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d51116"
    },
    d: "m17.33 5 1.36 1.3v.07L17.25 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d61116"
    },
    d: "m17.4 5 1.29 1.23v.07L17.33 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d71016"
    },
    d: "m17.47 5 1.22 1.16v.07L17.4 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d81016"
    },
    d: "m17.54 5 1.15 1.09v.07L17.47 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d91016"
    },
    d: "m17.62 5 1.07 1.02v.07L17.54 5h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#da1016"
    },
    d: "m17.69 5 1 .95v.07L17.62 5h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db1016"
    },
    d: "m17.76 5 .93.88v.07l-1-.95h.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc1016"
    },
    d: "m17.84 5 .85.81v.07L17.76 5h.08z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "m17.91 5 .78.74v.07L17.84 5h.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M18.69 5.74 17.91 5h.78v.74z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M12 5.87a.33.33 0 0 1-.33-.33V4.36a.34.34 0 0 1 .67 0v1.18a.34.34 0 0 1-.34.33z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M8.65 6.7a.34.34 0 0 1-.29-.17l-.59-1a.34.34 0 0 1 .12-.45.34.34 0 0 1 .46.12l.59 1a.35.35 0 0 1-.29.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M6.17 9.08A.33.33 0 0 1 6 9l-1-.56A.34.34 0 0 1 4.86 8a.34.34 0 0 1 .46-.12l1 .59a.33.33 0 0 1-.17.62z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M5.22 12.38H4a.33.33 0 0 1-.33-.33.32.32 0 0 1 .33-.33h1.22a.33.33 0 0 1 .33.33.33.33 0 0 1-.33.33z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M5 16.3a.33.33 0 0 1-.29-.16.34.34 0 0 1 .12-.45l1-.59a.33.33 0 0 1 .45.12.34.34 0 0 1-.12.45l-1 .59a.29.29 0 0 1-.16.04z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M7.83 19.21a.32.32 0 0 1-.28-.49l.59-1a.33.33 0 1 1 .57.33l-.59 1a.34.34 0 0 1-.29.16z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M17.67 9.3a.34.34 0 0 1-.29-.16.33.33 0 0 1 .12-.45l1-.59a.34.34 0 0 1 .46.12.33.33 0 0 1-.13.45l-1 .59a.32.32 0 0 1-.16.04z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M15.29 6.83a.34.34 0 0 1-.17 0 .33.33 0 0 1-.12-.5l.59-1a.33.33 0 0 1 .57.33l-.59 1a.32.32 0 0 1-.28.17z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m13.9 5.43-.21-.07.25-.75.21.07-.25.75z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m10.01 5.38-.18-.71.21-.05.18.7-.21.06z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m6.84 7.21-.54-.55.16-.15.54.55-.16.15z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m5.11 10.38-.86-.23.06-.21.85.23-.05.21z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m4.21 14.19-.06-.21.93-.24.06.21-.93.24z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m6.2 17.72-.16-.16.71-.7.16.16-.71.7z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m9.68 19.77-.21-.06.27-.98.21.06-.27.98z"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 14,
    height: 18,
    transform: "translate(3.19 3.08)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAACXBIWXMAAAsSAAALEgHS3X78AAABMUlEQVQ4T52SMY7CMBBF3wxBMkQooqLiJtRUlEiUdDQchyvQ0YYDcAguEqIYCPZssWIXQVDYfZIb+7+RRzNiZjRxOBys3++TZRmqiqqSpimj0UgAkmchz3NzzuGcQ1UBEBG63S4A3ntzzv2K2+3WkiSh1+sRY2Qymchz0dPpZM45RET0fnm5XLjdbtR1zXQ6fZEABoOBiIgAKMBms7G7NJ/PG6VnOmmaWgiBTqfDarX6SALQsiwxM9br9ccSQOK953w+t+VeUO99W6YRBaiqqi33QvJuc9pIYoz8R9YQAjFGlsvln2wxsx+pqip2u91HY5H7NxeLhYUQ8N6z3+9bZXnsbzabWV3XFEVBURQcj8e3BZQH8jyXsiy5Xq8AZFlmItLcu5k1nvF4bMPh0L4jr+9f3YmrGUUvABwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.47 12h-.88a7.55 7.55 0 0 0-3.68-6.51l.45-.75A8.49 8.49 0 0 1 20.47 12z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17 16.94H9v-.71l-.22.07v-.15l.37-.15z",
    style: {
      opacity: 0.7,
      fill: "#f1f2f2"
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M7.51 14.85h-.63v-.12l.3-.32a.74.74 0 0 0 .09-.12.16.16 0 0 0 0-.09.15.15 0 0 0 0-.1.14.14 0 0 0-.09 0 .12.12 0 0 0-.1 0 .18.18 0 0 0 0 .11h-.22a.26.26 0 0 1 0-.15A.23.23 0 0 1 7 14a.33.33 0 0 1 .17 0 .31.31 0 0 1 .23 0 .24.24 0 0 1 .08.19.25.25 0 0 1 0 .14.51.51 0 0 1-.12.16l-.21.23h.4z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M6.57 11.93h.1a.15.15 0 0 0 .1 0 .13.13 0 0 0-.18-.18.1.1 0 0 0 0 .07h-.22a.2.2 0 0 1 0-.13.33.33 0 0 1 .11-.09h.15a.32.32 0 0 1 .23.07.23.23 0 0 1 .14.13.21.21 0 0 1 0 .12.25.25 0 0 1-.1.08.2.2 0 0 1 .11.09.18.18 0 0 1 0 .13.25.25 0 0 1-.09.2.43.43 0 0 1-.24.07.38.38 0 0 1-.22-.07.25.25 0 0 1-.09-.2h.18a.13.13 0 0 0 0 .09.17.17 0 0 0 .1 0 .15.15 0 0 0 .1 0 .18.18 0 0 0 0-.09c0-.1-.05-.14-.15-.14h-.1z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M7.48 9.49h.1v.14h-.1v.2H7.3v-.2h-.38v-.11l.38-.61h.19zm-.39 0h.21v-.33z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m9.1 7.74.06-.47h.52v.15h-.37v.2a.31.31 0 0 1 .13 0 .25.25 0 0 1 .21.08.32.32 0 0 1 .08.23.42.42 0 0 1 0 .16.38.38 0 0 1-.11.11.43.43 0 0 1-.17 0 .28.28 0 0 1-.15 0 .2.2 0 0 1-.11-.09.24.24 0 0 1-.05-.14h.18A.25.25 0 0 0 9.3 8a.16.16 0 0 0 .09 0 .12.12 0 0 0 .1 0 .21.21 0 0 0 0-.12.15.15 0 0 0 0-.12.12.12 0 0 0-.11 0 .17.17 0 0 0-.1 0z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M12.21 6.59v.15a.32.32 0 0 0-.2.07.26.26 0 0 0-.11.19.25.25 0 0 1 .19-.07.26.26 0 0 1 .19.08.35.35 0 0 1 .07.23.27.27 0 0 1 0 .16.32.32 0 0 1-.11.12.42.42 0 0 1-.16 0 .33.33 0 0 1-.24-.1.4.4 0 0 1-.09-.27V7.1a.6.6 0 0 1 .06-.27.44.44 0 0 1 .16-.17.43.43 0 0 1 .25-.07zm-.21.47a.12.12 0 0 0-.08 0 .1.1 0 0 0 0 .06v.05a.31.31 0 0 0 0 .15.14.14 0 0 0 .11 0 .12.12 0 0 0 .09 0 .2.2 0 0 0 0-.24.12.12 0 0 0-.12-.02z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m15 7.49-.36.82h-.19l.36-.78h-.46v-.15H15z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M16.81 9.69a.27.27 0 0 1 0 .12.34.34 0 0 1-.09.08.22.22 0 0 1 .1.09.2.2 0 0 1 0 .13.28.28 0 0 1-.08.2.41.41 0 0 1-.46 0 .28.28 0 0 1-.08-.2.18.18 0 0 1 0-.13.22.22 0 0 1 .1-.09.24.24 0 0 1-.09-.08.27.27 0 0 1 0-.12.22.22 0 0 1 .08-.19.35.35 0 0 1 .42 0 .24.24 0 0 1 .1.19zm-.16.41a.13.13 0 0 0 0-.1.15.15 0 0 0-.18 0 .13.13 0 0 0 0 .1.12.12 0 0 0 0 .09.13.13 0 0 0 .1 0 .14.14 0 0 0 .13-.13zm0-.4a.12.12 0 0 0 0-.09.12.12 0 0 0-.16 0 .12.12 0 0 0 0 .09.11.11 0 0 0 0 .08.1.1 0 0 0 .16 0 .11.11 0 0 0-.02-.08z"
  }))), /*#__PURE__*/React.createElement("image", {
    width: 37,
    height: 34,
    transform: "matrix(.21 0 0 .21 11.03 6.08)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAiCAYAAADYmxC7AAAACXBIWXMAADRJAAA0SQGcx3VBAAACAElEQVRYR83YPWsUURQG4GeCxoAfrK4YA9oYrKy0CVgopDa/NmIp2ARWxC7aaEBEYjQhURQkizsWZ4YMm50PJzujp1nYvcXDPe/cc2eTNE39b3WubkFXlSRJggUsZp8THGPyT1AZ6DyGuI1L+IYPOOwdVQCtYA2PBO4tNvGjN1ShXUtYFqAneIBf+JT93k+mptq1intYx/1syRu8xC7GnaNmtGtdoG5hjFd4ihH2dR30KdBDbAjYAEcCtIkt2S6laZp2girJz4aADXEgduYUiA4yVZGfNSegLSUg5oyqyM8dXNEAxBxRFfm5IVr5VQMQc0DV5OdmtuyzhiDOiKrJTysQJG1vCTX5GYgB+0XFU1ZWrXaqQX6OsINtPBewRiBaoEpA0/kZCcw23ounrhGIv0C1CPQIe2LYTpqCaIjqKtBlVYuqCPQqrmXL5gaiBlUR6GVcwG9zBlGCqsnPioCOdQBiBqomP0XQrg5ATKFq8jPUA4gCqiY/S6KdnYPIUBUHYt4uegJxslMLuG52oCfiANzTYo61qRy1KF4KHzsd6AMxKlrNsTZV3KmL4nQeZN/n7TrTHGtTOWqCn+LcORQ7V7y6tp5jbSpHHeMjXuAy7uIdnuk4P7OquFP7YkfG4qK2g9d6BlG4eRaOhavizeO7aGWvIKauw4WZl/9f1Hl+ZtUf0RM++k4lkegAAAAASUVORK5CYII=",
    style: {
      opacity: 0.75,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "m17.53 6.79-5.93 5.28V6.79h5.93z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "m17.61 6.79-6.01 5.35v-.07l5.93-5.28h.08z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec1b23"
    },
    d: "m17.69 6.79-6.09 5.42v-.07l6.01-5.35h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb1a22"
    },
    d: "m17.77 6.79-6.17 5.49v-.07l6.09-5.42h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ea1a21"
    },
    d: "m17.85 6.79-6.25 5.56v-.07l6.17-5.49h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e91920"
    },
    d: "m17.93 6.79-6.33 5.63v-.07l6.25-5.56h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8181f"
    },
    d: "m18.01 6.79-6.41 5.7v-.07l6.33-5.63h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7171e"
    },
    d: "m18.09 6.79-6.49 5.77v-.07l6.41-5.7h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6161d"
    },
    d: "m18.17 6.79-6.57 5.84v-.07l6.49-5.77h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4161d"
    },
    d: "m18.25 6.79-6.63 5.9h-.02v-.06l6.57-5.84h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3151c"
    },
    d: "m18.3 6.81-6.6 5.88h-.08l6.63-5.9h.05v.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2141b"
    },
    d: "m18.3 6.88-6.52 5.81h-.08l6.6-5.88v.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1131a"
    },
    d: "m18.3 6.96-6.44 5.73h-.08l6.52-5.81v.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e01219"
    },
    d: "m18.3 7.03-6.36 5.66h-.08l6.44-5.73v.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#df1218"
    },
    d: "m18.3 7.1-6.28 5.59h-.08l6.36-5.66v.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#de1117"
    },
    d: "m18.3 7.17-6.2 5.52h-.08L18.3 7.1v.07z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "m18.3 7.24-6.12 5.45h-.08l6.2-5.52v.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "m12.18 12.69 6.12-5.45v5.45h-6.12z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBhp);
export default __webpack_public_path__ + "static/media/TeamBHP.702e5aae3b54f9aee35eab0ed6de8c14.svg";
export { ForwardRef as ReactComponent };